import { render, staticRenderFns } from "./ProductSpecificationDocumentPopUp.vue?vue&type=template&id=5a8ea5f8&scoped=true&"
import script from "./ProductSpecificationDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecificationDocumentPopUp.vue?vue&type=style&index=0&id=5a8ea5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ea5f8",
  null
  
)

export default component.exports